import { pick } from "../../lib/i18n";
import type { DimensionReview, ProductFile } from "../../types";

const copy = {
  pl: {
    warning: "Ten odczyt wymaga sprawdzenia źródła, jednostki lub mierzonej części. Dodaj go do wymiarów dopiero po weryfikacji.",
    tooltip: (source: string) => `Odczyt ze źródła oznaczony jako wymagający weryfikacji. ${source}`,
    missingSource: "Źródło nieznane.",
    add: "Dodaj",
    reject: "Odrzuć",
  },
  en: {
    warning: "Verify the source, unit and measured component before adding this reading to the product dimensions.",
    tooltip: (source: string) => `Read from the source and flagged as requiring verification. ${source}`,
    missingSource: "Source unknown.",
    add: "Add",
    reject: "Dismiss",
  },
};

export function reviewItemKey(item: DimensionReview): string {
  const label = item.source_label || item.field;
  return `${item.source_file_id}:${label}:${item.value}`;
}

function dedupeByDisplayIdentity(items: DimensionReview[]): DimensionReview[] {
  const seen = new Set<string>();
  const result: DimensionReview[] = [];
  for (const item of items) {
    const key = reviewItemKey(item);
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(item);
  }
  return result;
}

type Props = {
  items: DimensionReview[];
  files: ProductFile[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  resolvedKeys: Set<string>;
  onAccept: (item: DimensionReview) => void;
  onReject: (item: DimensionReview) => void;
};

export function DimensionReviewNotice({ items, files, values, onChange, resolvedKeys, onAccept, onReject }: Props) {
  const t = pick(copy);
  const visible = dedupeByDisplayIdentity(items).filter((item) => !resolvedKeys.has(reviewItemKey(item)));
  if (visible.length === 0) return null;

  return (
    <div className="dimension-review-inline">
      <p className="dimension-review-inline__hint">{t.warning}</p>
      {visible.map((item) => {
        const source = files.find((file) => file.id === item.source_file_id);
        const label = item.source_label || item.field;
        const sourceText = source ? source.filename : t.missingSource;
        const tooltip = item.quote ? `${t.tooltip(sourceText)}\n\n"${item.quote}"` : t.tooltip(sourceText);

        const key = reviewItemKey(item);
        return (
          <div key={key} className="dimension-review-inline__row">
            <span className="mono" title={tooltip}>{label}</span>
            <input className="v3-input" value={values[key] ?? item.value} aria-label={label} title={tooltip} onChange={(event) => onChange(key, event.target.value)} />
            <div className="dimension-review-inline__actions">
              <button type="button" onClick={() => onAccept(item)} className="dimension-review-inline__accept" title={t.add}>{t.add}</button>
              <button type="button" onClick={() => onReject(item)} className="dimension-review-inline__reject" title={t.reject}>×</button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
